module.exports = __webpack_public_path__ + "decc2befaadfdecd0a95dae12e95ad38.svg";